import React, {type FC, useCallback} from 'react';

import {Analytics} from '../../../../services/analytics';
import {ColorActionsMenu} from './ColorActionsMenu';
import {useSemanticLegendSettingsContext} from './SemanticLegendSettingsWithCategoricalConfigContextProvider';
import {invertColorsWithCategoricalConfig} from './utils/invertColors';
import {resetColors} from './utils/resetColors';
import {useGetWorkspaceSettingsSemanticLegendPaletteWithCategoricalConfig} from './utils/useGetWorkspaceSettingsSemanticLegendPaletteWithCategoricalConfig';

interface SemanticLegendBucketsActionsProps {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isOpen: boolean;
}

export const SemanticLegendBucketsActionsWithCategoricalConfig: FC<
  SemanticLegendBucketsActionsProps
> = ({setIsOpen, isOpen}) => {
  const {semanticLegendSettings, updateSemanticLegendSettings} =
    useSemanticLegendSettingsContext();
  const getSemanticLegendPalette =
    useGetWorkspaceSettingsSemanticLegendPaletteWithCategoricalConfig();

  const trackInvertColors = useCallback(() => {
    Analytics.track('Semantic legend invert colors', {
      newValue: semanticLegendSettings.yAxisValue,
    });
  }, [semanticLegendSettings.yAxisValue]);
  const trackResetColors = useCallback(() => {
    Analytics.track('Semantic legend reset colors', {
      newValue: semanticLegendSettings.yAxisValue,
    });
  }, [semanticLegendSettings.yAxisValue]);

  const onInvertColors = useCallback(() => {
    updateSemanticLegendSettings?.(
      invertColorsWithCategoricalConfig(
        semanticLegendSettings,
        getSemanticLegendPalette(semanticLegendSettings.yAxisValue)
      )
    );
  }, [
    semanticLegendSettings,
    updateSemanticLegendSettings,
    getSemanticLegendPalette,
  ]);

  const onResetColors = useCallback(() => {
    updateSemanticLegendSettings?.(resetColors(semanticLegendSettings ?? {}));
  }, [semanticLegendSettings, updateSemanticLegendSettings]);

  return (
    <ColorActionsMenu
      setIsOpen={setIsOpen}
      isOpen={isOpen}
      trackInvertColors={trackInvertColors}
      trackResetColors={trackResetColors}
      onInvertColors={onInvertColors}
      onResetColors={onResetColors}
    />
  );
};
